class SingleFilter {
  constructor($singleFilter) {
    this.$singleFilter = $singleFilter;
    this.$form = $singleFilter.querySelector('.single-filter__form');
    this.$modal = this.$singleFilter.querySelector('.single-filter__modal-wrapper');
    this.$modalContent = this.$singleFilter.querySelector('.single-filter__modal');
    this.$openModalButton = this.$singleFilter.querySelector('.single-filter__button');
    this.$closeModalButton = this.$singleFilter.querySelector('.single-filter__close-button');
    this.$radioButtons = this.$singleFilter.querySelectorAll('.single-filter__radio');
    this.init();
  }

  init() {
    this.$openModalButton.addEventListener('click', this.showModal.bind(this));
    this.$closeModalButton.addEventListener('click', this.hideModal.bind(this));
    this.$modal.addEventListener('click', this.handleOutsideClick.bind(this));
    this.$radioButtons.forEach((radioButton) => {
      radioButton.addEventListener('change', (event) => {
        this.hideModal();
        const text = event.target.closest('.single-filter__label').textContent.trim('');
        this.$form.dataset.select = text;
      });
    });
  }

  showModal() {
    this.$modal.classList.add('is-active');
  }

  hideModal() {
    this.$modal.classList.remove('is-active');
  }

  handleOutsideClick(event) {
    if (!this.$modalContent.contains(event.target)) {
      this.hideModal();
    }
  }
}

const singleFilterInit = () => {
  const singleFilters = document.querySelectorAll('[data-single-form]');

  if (singleFilters.length) {
    singleFilters.forEach((singleFilter) => {
      new SingleFilter(singleFilter);
    });
  }
};

export { singleFilterInit };
